// extracted by mini-css-extract-plugin
export default {"container":"quicknav_container__aLbF9","navbar":"quicknav_navbar__ILqnx","home":"quicknav_home__nO6Ee","word":"quicknav_word__uPMlp"};